export default __webpack_public_path__ + "static/media/purpleArrowDown.810ad7a1.svg";